import React from 'react';
import './About.css';

const pillars = [
  { icon: 'bi-building', title: 'Industrial Expertise', desc: 'Wide range of industrial and commercial requirements catered with precision and reliability across India.' },
  { icon: 'bi-wrench-adjustable', title: 'Retrofit & Maintenance', desc: 'Expert retrofit works and maintenance support for all types and makes of equipment, any brand.' },
  { icon: 'bi-thermometer-half', title: 'HVAC Specialists', desc: 'Cleanroom and Dry Room projects handled to the highest standards of quality and efficiency.' },
  { icon: 'bi-patch-check', title: 'Trusted Pan-India', desc: 'Our services extend across India, serving diverse industrial and commercial sectors reliably.' },
];

function About() {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="row align-items-center g-5">

          {/* Left — text */}
          <div className="col-lg-5">
            <div className="section-eyebrow">Who We Are</div>
            <h2 className="section-title">A Professionally Managed Organisation</h2>
            <p className="section-sub">
              Air Techno Services (ATS) brings extensive experience in the service industry,
              delivering comprehensive solutions across Dehumidification, Humidification, HVAC,
              Cleanrooms and Dry Rooms throughout India.
            </p>
            <p className="section-sub mt-3">
              We are committed to delivering reliable, efficient and cost-effective solutions,
              backed by decades of technical expertise and a customer-focused approach.
            </p>

            <div className="about-highlight mt-4">
              <i className="bi bi-quote about-quote-icon"></i>
              <p className="about-quote-text">
                "Reliable, efficient and cost-effective solutions — that's our promise to every client."
              </p>
            </div>
          </div>

          {/* Right — cards */}
          <div className="col-lg-7">
            <div className="row g-3">
              {pillars.map((p, i) => (
                <div className="col-sm-6" key={i}>
                  <div className="about-card">
                    <div className="about-card-icon">
                      <i className={`bi ${p.icon}`}></i>
                    </div>
                    <h5 className="about-card-title">{p.title}</h5>
                    <p className="about-card-desc">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default About;
